(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["collapse~index"],{

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// CONCATENATED MODULE: ./src/base/vc-collapse/src/PanelContent.jsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var PanelContent = ({
  name: 'PanelContent',
  props: {
    prefixCls: vue_types["a" /* default */].string,
    isActive: vue_types["a" /* default */].bool,
    destroyInactivePanel: vue_types["a" /* default */].bool,
    forceRender: vue_types["a" /* default */].bool,
    role: vue_types["a" /* default */].any
  },
  data: function data() {
    return {
      isPanelActive: undefined
    };
  },
  render: function render() {
    var _contentCls;

    var h = arguments[0];
    this.isPanelActive = this.forceRender || this.isPanelActive || this.isActive;

    if (!this.isPanelActive) {
      return null;
    }

    var _this$$props = this.$props,
        prefixCls = _this$$props.prefixCls,
        isActive = _this$$props.isActive,
        destroyInactivePanel = _this$$props.destroyInactivePanel,
        forceRender = _this$$props.forceRender,
        role = _this$$props.role;
    var $slots = this.$slots;
    var contentCls = (_contentCls = {}, _defineProperty(_contentCls, "".concat(prefixCls, "-content"), true), _defineProperty(_contentCls, "".concat(prefixCls, "-content-active"), isActive), _contentCls);
    var child = !forceRender && !isActive && destroyInactivePanel ? null : h("div", {
      "class": "".concat(prefixCls, "-content-box")
    }, [$slots.default]);
    return h("div", {
      "class": contentCls,
      attrs: {
        role: role
      }
    }, [child]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-collapse/src/commonProps.js


var commonProps_collapseProps = function collapseProps() {
  return {
    prefixCls: vue_types["a" /* default */].string,
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]))]),
    defaultActiveKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]))]),
    accordion: vue_types["a" /* default */].bool,
    destroyInactivePanel: vue_types["a" /* default */].bool,
    bordered: vue_types["a" /* default */].bool,
    expandIcon: vue_types["a" /* default */].func,
    openAnimation: vue_types["a" /* default */].object,
    expandIconPosition: vue_types["a" /* default */].oneOf(['left', 'right'])
  };
};

var commonProps_panelProps = function panelProps() {
  return {
    openAnimation: vue_types["a" /* default */].object,
    prefixCls: vue_types["a" /* default */].string,
    header: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number, vue_types["a" /* default */].node]),
    headerClass: vue_types["a" /* default */].string,
    showArrow: vue_types["a" /* default */].bool,
    isActive: vue_types["a" /* default */].bool,
    destroyInactivePanel: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool,
    disabledHeaderClick: vue_types["a" /* default */].bool,
    accordion: vue_types["a" /* default */].bool,
    forceRender: vue_types["a" /* default */].bool,
    expandIcon: vue_types["a" /* default */].func,
    extra: vue_types["a" /* default */].any,
    panelKey: vue_types["a" /* default */].any
  };
};


// CONCATENATED MODULE: ./src/base/vc-collapse/src/Panel.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Panel_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Panel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ var Panel = ({
  name: 'Panel',
  props: Object(props_util["initDefaultProps"])(commonProps_panelProps(), {
    showArrow: true,
    isActive: false,
    destroyInactivePanel: false,
    headerClass: '',
    forceRender: false
  }),
  methods: {
    handleItemClick: function handleItemClick() {
      this.$emit('itemClick', this.panelKey);
    },
    handleKeyPress: function handleKeyPress(e) {
      if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
        this.handleItemClick();
      }
    }
  },
  render: function render() {
    var _headerCls, _itemCls;

    var h = arguments[0];
    var _this$$props = this.$props,
        prefixCls = _this$$props.prefixCls,
        headerClass = _this$$props.headerClass,
        isActive = _this$$props.isActive,
        showArrow = _this$$props.showArrow,
        destroyInactivePanel = _this$$props.destroyInactivePanel,
        disabled = _this$$props.disabled,
        openAnimation = _this$$props.openAnimation,
        accordion = _this$$props.accordion,
        forceRender = _this$$props.forceRender,
        expandIcon = _this$$props.expandIcon,
        extra = _this$$props.extra;
    var $slots = this.$slots;
    var transitionProps = {
      props: Object.assign({
        appear: true,
        css: false
      }),
      on: _objectSpread({}, openAnimation)
    };
    var headerCls = (_headerCls = {}, Panel_defineProperty(_headerCls, "".concat(prefixCls, "-header"), true), Panel_defineProperty(_headerCls, headerClass, headerClass), _headerCls);
    var header = Object(props_util["getComponentFromProp"])(this, 'header');
    var itemCls = (_itemCls = {}, Panel_defineProperty(_itemCls, "".concat(prefixCls, "-item"), true), Panel_defineProperty(_itemCls, "".concat(prefixCls, "-item-active"), isActive), Panel_defineProperty(_itemCls, "".concat(prefixCls, "-item-disabled"), disabled), _itemCls);
    var icon = h("i", {
      "class": "arrow"
    });

    if (showArrow && typeof expandIcon === 'function') {
      icon = expandIcon(this.$props);
    }

    return h("div", {
      "class": itemCls,
      attrs: {
        role: "tablist"
      }
    }, [h("div", {
      "class": headerCls,
      on: {
        "click": this.handleItemClick.bind(this),
        "keypress": this.handleKeyPress
      },
      attrs: {
        role: accordion ? 'tab' : 'button',
        tabIndex: disabled ? -1 : 0,
        "aria-expanded": isActive
      }
    }, [showArrow && icon, header, extra && h("div", {
      "class": "".concat(prefixCls, "-extra")
    }, [extra])]), h("transition", transitionProps, [h(PanelContent, {
      directives: [{
        name: "show",
        value: isActive
      }],
      attrs: {
        prefixCls: prefixCls,
        isActive: isActive,
        destroyInactivePanel: destroyInactivePanel,
        forceRender: forceRender,
        role: accordion ? 'tabpanel' : null
      }
    }, [$slots.default])])]);
  }
});
// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/css_animation/index.js
var css_animation = __webpack_require__(39);

// CONCATENATED MODULE: ./src/base/vc-collapse/src/openAnimationFactory.js


function animate(node, show, transitionName, done) {
  var height;
  return Object(css_animation["a" /* default */])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = "".concat(node.offsetHeight, "px");
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = "".concat(show ? height : 0, "px");
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, "".concat(prefixCls, "-anim"), done);
    },
    leave: function leave(node, done) {
      return animate(node, false, "".concat(prefixCls, "-anim"), done);
    }
  };
}

/* harmony default export */ var openAnimationFactory = (animation);
// CONCATENATED MODULE: ./src/base/vc-collapse/src/Collapse.jsx
function Collapse_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }







function _toArray(activeKey) {
  var currentActiveKey = activeKey;

  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }

  return currentActiveKey.map(function (key) {
    return String(key);
  });
}

/* harmony default export */ var Collapse = ({
  name: 'Collapse',
  mixins: [BaseMixin["a" /* default */]],
  model: {
    prop: 'activeKey',
    event: 'change'
  },
  props: Object(props_util["initDefaultProps"])(commonProps_collapseProps(), {
    prefixCls: 'rc-collapse',
    accordion: false,
    destroyInactivePanel: false
  }),
  data: function data() {
    var _this$$props = this.$props,
        activeKey = _this$$props.activeKey,
        defaultActiveKey = _this$$props.defaultActiveKey,
        openAnimation = _this$$props.openAnimation,
        prefixCls = _this$$props.prefixCls;
    var currentActiveKey = defaultActiveKey;

    if (Object(props_util["hasProp"])(this, 'activeKey')) {
      currentActiveKey = activeKey;
    }

    var currentOpenAnimations = openAnimation || openAnimationFactory(prefixCls);
    return {
      currentOpenAnimations: currentOpenAnimations,
      stateActiveKey: _toArray(currentActiveKey)
    };
  },
  watch: {
    activeKey: function activeKey(val) {
      this.setState({
        stateActiveKey: _toArray(val)
      });
    },
    openAnimation: function openAnimation(val) {
      this.setState({
        currentOpenAnimations: val
      });
    }
  },
  methods: {
    onClickItem: function onClickItem(key) {
      var activeKey = this.stateActiveKey;

      if (this.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = _toConsumableArray(activeKey);
        var index = activeKey.indexOf(key);
        var isActive = index > -1;

        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }

      this.setActiveKey(activeKey);
    },
    getNewChild: function getNewChild(child, index) {
      if (Object(props_util["isEmptyElement"])(child)) return;
      var activeKey = this.stateActiveKey;
      var _this$$props2 = this.$props,
          prefixCls = _this$$props2.prefixCls,
          accordion = _this$$props2.accordion,
          destroyInactivePanel = _this$$props2.destroyInactivePanel,
          expandIcon = _this$$props2.expandIcon; // If there is no key provide, use the panel order as default key

      var key = child.key || String(index);

      var _getPropsData = Object(props_util["getPropsData"])(child),
          header = _getPropsData.header,
          headerClass = _getPropsData.headerClass,
          disabled = _getPropsData.disabled,
          disabledHeaderClick = _getPropsData.disabledHeaderClick;

      var isActive = false;

      if (accordion) {
        isActive = activeKey[0] === key;
      } else {
        isActive = activeKey.indexOf(key) > -1;
      }

      var panelEvents = {};

      if (!disabled && disabled !== '') {
        if (!disabledHeaderClick && disabledHeaderClick !== '') {
          panelEvents = {
            itemClick: this.onClickItem
          };
        }
      }

      var props = {
        key: key,
        props: {
          panelKey: key,
          header: header,
          headerClass: headerClass,
          isActive: isActive,
          prefixCls: prefixCls,
          destroyInactivePanel: destroyInactivePanel,
          openAnimation: this.currentOpenAnimations,
          accordion: accordion,
          expandIcon: expandIcon
        },
        on: panelEvents
      };
      return Object(vnode["a" /* cloneElement */])(child, props);
    },
    getItems: function getItems() {
      var _this = this;

      var newChildren = [];
      this.$slots.default && this.$slots.default.forEach(function (child, index) {
        newChildren.push(_this.getNewChild(child, index));
      });
      return newChildren;
    },
    setActiveKey: function setActiveKey(activeKey) {
      this.setState({
        stateActiveKey: activeKey
      });
      this.$emit('change', this.accordion ? activeKey[0] : activeKey);
    }
  },
  render: function render() {
    var h = arguments[0];
    var _this$$props3 = this.$props,
        prefixCls = _this$$props3.prefixCls,
        accordion = _this$$props3.accordion;

    var collapseClassName = Collapse_defineProperty({}, prefixCls, true);

    return h("div", {
      "class": collapseClassName,
      attrs: {
        role: accordion ? 'tablist' : null
      }
    }, [this.getItems()]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-collapse/index.js



Collapse.Panel = Panel;

/* harmony default export */ var vc_collapse = (Collapse);
// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/collapse/collapse.jsx
function collapse_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function collapse_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { collapse_ownKeys(Object(source), true).forEach(function (key) { collapse_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { collapse_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function collapse_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* harmony default export */ var collapse = ({
  name: "MegCollapse",
  model: {
    prop: "activeKey",
    event: "change"
  },
  props: Object(props_util["initDefaultProps"])(commonProps_collapseProps(), {
    bordered: true,
    expandIconPosition: "left"
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  methods: {
    renderExpandIcon: function renderExpandIcon(panelProps, prefixCls) {
      var h = this.$createElement;
      var expandIcon = Object(props_util["getComponentFromProp"])(this, "expandIcon", panelProps);
      var icon = expandIcon || h("meg-icon", {
        attrs: {
          name: "megui-right",
          rotate: panelProps.isActive ? 90 : undefined,
          width: "1em",
          height: "1em"
        }
      });
      var iconWrap = h("span", {
        attrs: {
          "aria-label": "right"
        }
      }, [icon]);
      return Object(props_util["isValidElement"])(Array.isArray(expandIcon) ? icon[0] : icon) ? Object(vnode["a" /* cloneElement */])(iconWrap, {
        class: "".concat(prefixCls, "-arrow")
      }) : iconWrap;
    }
  },
  render: function render() {
    var _collapseClassName,
        _this = this;

    var h = arguments[0];
    var customizePrefixCls = this.prefixCls,
        bordered = this.bordered,
        expandIconPosition = this.expandIconPosition;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls("collapse", customizePrefixCls);
    var collapseClassName = (_collapseClassName = {}, collapse_defineProperty(_collapseClassName, "".concat(prefixCls, "-borderless"), !bordered), collapse_defineProperty(_collapseClassName, "".concat(prefixCls, "-icon-position-").concat(expandIconPosition), true), _collapseClassName);
    var rcCollapeProps = {
      props: collapse_objectSpread(collapse_objectSpread({}, Object(props_util["getOptionProps"])(this)), {}, {
        prefixCls: prefixCls,
        expandIcon: function expandIcon(panelProps) {
          return _this.renderExpandIcon(panelProps, prefixCls);
        }
      }),
      class: collapseClassName,
      on: Object(props_util["getListeners"])(this)
    };
    return h(vc_collapse, rcCollapeProps, [this.$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/components/collapse/collapse-panel.jsx
function collapse_panel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function collapse_panel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { collapse_panel_ownKeys(Object(source), true).forEach(function (key) { collapse_panel_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { collapse_panel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function collapse_panel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ var collapse_panel = ({
  name: 'MegCollapsePanel',
  props: collapse_panel_objectSpread({}, commonProps_panelProps()),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var customizePrefixCls = this.prefixCls,
        _this$showArrow = this.showArrow,
        showArrow = _this$showArrow === void 0 ? true : _this$showArrow;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('collapse', customizePrefixCls);

    var collapsePanelClassName = collapse_panel_defineProperty({}, "".concat(prefixCls, "-no-arrow"), !showArrow);

    var rcCollapePanelProps = {
      props: collapse_panel_objectSpread(collapse_panel_objectSpread({}, Object(props_util["getOptionProps"])(this)), {}, {
        prefixCls: prefixCls,
        extra: Object(props_util["getComponentFromProp"])(this, 'extra')
      }),
      class: collapsePanelClassName,
      on: Object(props_util["getListeners"])(this)
    };
    var header = Object(props_util["getComponentFromProp"])(this, 'header');
    return h(vc_collapse.Panel, rcCollapePanelProps, [this.$slots.default, header ? h("template", {
      slot: "header"
    }, [header]) : null]);
  }
});
// CONCATENATED MODULE: ./src/components/collapse/index.jsx

 // import "./style/index.scss";

collapse.Panel = collapse_panel;
/* istanbul ignore next */

collapse.install = function (Vue) {
  Vue.component(collapse.name, collapse);
  Vue.component(collapse_panel.name, collapse_panel);
};

/* harmony default export */ var components_collapse = __webpack_exports__["default"] = (collapse);

/***/ })

}]);